<template>
  <div>
    <h1 class="text-3xl sm:text-4xl font-bold text-gray-900">Crea tu cuenta</h1>

    <div class="mt-8 space-y-5">
      <div class="space-y-4">
        <p class="font-medium text-neutral-700">
          Por favor selecciona el tipo de cuenta
        </p>
        <MobSegmentedButton
          class="m-auto"
          v-model="registerForm.userType"
          :items="userTypes"
        ></MobSegmentedButton>
      </div>

      <p class="font-medium text-neutral-700">
        Selecciona un método para crear cuenta
      </p>

      <button class="mob-btn w-full" @click="googleLoginV2()">
        <img src="/icons/google.svg" alt="" />
        Ingresa con Google
      </button>

      <p class="font-medium text-neutral-700">
        o crea tu cuenta con correo electrónico
      </p>

      <div class="space-y-4">
        <MobTextField
          label="Nombre"
          v-model="registerForm.name"
          :errorText="formErrorMessage.name"
        />
        <MobTextField
          label="Email"
          v-model="registerForm.email"
          placeholder="ejemplo@correo.com"
          :errorText="formErrorMessage.email"
        />
        <MobTextField
          label="Contraseña"
          v-model="registerForm.password"
          type="password"
          :errorText="
            formErrorMessage.password
              ? formErrorMessage.password
              : formErrorMessage.passwordValidation
              ? formErrorMessage.passwordValidation
              : null
          "
        />
        <MobTextField
          v-model="registerForm.passwordRepeat"
          label="Repetir contraseña"
          type="password"
          :errorText="formErrorMessage.passwordRepeat"
        />
        <MobCheckbox v-model="registerForm.terms" class="text-neutral-500">
          Estás de acuerdo con nuestras
          <a href="/terms-and-conditions" target="_blank">
            <span class="underline">Condiciones de Servicio</span> y
            <span class="underline"> Política de Privacidad </span> </a
          >.
        </MobCheckbox>
        <button
          class="mob-btn mob-cta-gold w-full"
          @click.prevent="register()"
        >
          Crear cuenta
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  MobSegmentedButton,
  MobTextField,
  MobCheckbox,
} from "@/views/V2/components";
import { handleGoogleLogin } from "@/Utils/oauth-helper";
import { getUserData } from "@/services/auth.service.js";
import { loadRegistrationIntent } from "@/views/V2/olimpiadas/registrationFlow";

export default {
  name: "RegisterForm",
  components: {
    MobSegmentedButton,
    MobTextField,
    MobCheckbox,
  },
  data() {
    return {
      userTypes: [
        { key: "ROLE_STUDENT", label: "Estudiante" },
        // { key: "ROLE_TEACHER", label: "Profesor" },
        { key: "ROLE_ACADEMIC_ADMIN", label: "Administrador académico" },
      ],
      registerForm: {
        userType: "ROLE_STUDENT",
        name: "",
        email: "",
        password: "",
        repeatPassword: "",
        terms: false,
      },
      formErrorMessage: {
        name: null,
        email: null,
        password: null,
        passwordRepeat: null,
        passwordValidation: null,
      },
      postRegister: false,
    };
  },
  methods: {
    register() {
      if (this.validateRegisterInfo()) {
        const payload = {
          ...this.registerForm,
          userType: this.registerForm.userType || "ROLE_STUDENT",
        };
        const verifyRedirect = this.getVerifyRedirect();
        if (verifyRedirect) {
          payload.verifyRedirect = verifyRedirect;
        }

        axios
          .post(
            `${import.meta.env.VITE_API_BASE_URL}/auth/signup`,
            payload
          )
          .then((apiResponse) => {
            if (apiResponse.status === 200 || apiResponse.status === 201) {
              if (apiResponse.data?.accessToken) {
                this.handleTokenLogin(apiResponse.data.accessToken);
                return;
              }
              if (apiResponse.data?.message) {
                this.$toasted.info(apiResponse.data.message, {
                  position: "top-center",
                  duration: 8000,
                });
              }
              this.$emit("postRegisterOk");
            }
          })
          .catch((error) => {
            const apiMessage = error.response?.data?.message;
            if (error.response?.status === 409 && apiMessage) {
              this.$toasted.info(apiMessage, {
                position: "top-center",
                duration: 8000,
              });
              this.$router.push({
                path: "/v2/auth/login",
                query: this.$route.query.redirect
                  ? { redirect: this.$route.query.redirect }
                  : {},
              });
              return;
            }
            this.$toasted.error(
              apiMessage ||
                "El correo ya existe, verifica que no haya una cuenta con ese correo o que no sea su correo personal de una cuenta de Facebook o Gmail existente dentro de la plataforma.",
              { position: "top-center", duration: 12000 }
            );
            error.response?.data?.name
              ? (this.formErrorMessage.name =
                  error.response.data.name.join(" "))
              : null;
            error.response?.data?.email
              ? (this.formErrorMessage.email =
                  error.response.data.email.join(" "))
              : null;
            error.response?.data?.password
              ? (this.formErrorMessage.password =
                  error.response.data.password.join(" "))
              : null;
            error.response?.data?.passwordRepeat
              ? (this.formErrorMessage.passwordRepeat =
                  error.response.data.passwordRepeat.join(" "))
              : null;
          });

      }
    },
    async handleTokenLogin(token) {
      try {
        const response = await getUserData(token);
        const roleNames = (response.data?.roles || []).map((role) => role.name);
        const isAcademicAdmin = roleNames.includes("ROLE_ACADEMIC_ADMIN");
        const hasStudentRole = roleNames.includes("ROLE_STUDENT");
        const hasAdminRole = roleNames.includes("ROLE_ADMIN");
        if (
          response.data &&
          (response.data.emailVerified ||
            ["google", "facebook"].includes(response.data.provider) ||
            isAcademicAdmin)
        ) {
          this.$store.dispatch("auth/setLogin", {
            ...response.data,
            ...{ token: token },
          });
          if (isAcademicAdmin && (hasStudentRole || hasAdminRole)) {
            this.$router.push("/v2/auth/role-select");
            return;
          }
          if (isAcademicAdmin) {
            this.$router.push("/teacher/groups");
            return;
          }
          this.$router.push("/dashboard");
          return;
        }
        this.$toasted.info("Por favor verifica tu email para continuar.", {
          position: "top-center",
          duration: 3000,
        });
      } catch (error) {
        this.$toasted.error(
          "No se pudo iniciar sesión automáticamente. Intenta iniciar sesión manualmente.",
          { position: "top-center", duration: 8000 }
        );
      }
    },
    getVerifyRedirect() {
      const queryRedirect = this.$route?.query?.redirect;
      const querySource = this.$route?.query?.source;

      if (queryRedirect && queryRedirect.startsWith("/olimpiadas")) {
        return "/olimpiadas";
      }
      if (querySource === "olimpiadas") {
        return "/olimpiadas";
      }

      const intent = loadRegistrationIntent();
      if (intent) {
        return "/olimpiadas";
      }

      return null;
    },
    async googleLoginV2() {
      const baseUrl = import.meta.env.VITE_GOOGLE_AUTH_URL;
      const url = new URL(baseUrl);
      url.searchParams.set("userType", this.registerForm.userType);
      await handleGoogleLogin(url.toString());
    },
    validateRegisterInfo() {
      let errorCount = 0;

      if (!this.registerForm.name) {
        this.formErrorMessage.name = "Este campo es requerido";
        errorCount++;
      } else {
        this.formErrorMessage.name = null;
      }
      if (!this.registerForm.email) {
        this.formErrorMessage.email = "Este campo es requerido";
        errorCount++;
      } else {
        this.formErrorMessage.email = null;
      }
      if (!this.registerForm.password) {
        this.formErrorMessage.password = "Este campo es requerido";
        errorCount++;
      } else {
        this.formErrorMessage.password = null;
      }
      if (!this.registerForm.passwordRepeat) {
        this.formErrorMessage.passwordRepeat = "Este campo es requerido";
        errorCount++;
      } else {
        this.formErrorMessage.passwordRepeat = null;
      }
      if (
        this.registerForm.passwordRepeat &&
        this.registerForm.password &&
        this.registerForm.password !== this.registerForm.passwordRepeat
      ) {
        this.formErrorMessage.passwordValidation =
          "Las contraseñas no coinciden.";
        errorCount++;
      } else {
        this.formErrorMessage.passwordValidation = null;
      }

      return errorCount === 0;
    },
    goToLogin() {
      // Redirect to login
      this.$router.push("/login");
    },
  },
};
</script>
